var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 47.265,
    height: 55.143,
    viewBox: "0 0 47.265 55.143",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "np_person_6124340_000000",
    d: "M59.765,53.515A13.785,13.785,0,0,0,45.98,39.73H26.286A13.785,13.785,0,0,0,12.5,53.515v3.939a3.938,3.938,0,0,0,3.939,3.939H55.827a3.938,3.938,0,0,0,3.939-3.939Zm-3.939,3.939H16.439V53.515a9.847,9.847,0,0,1,9.847-9.847H45.98a9.847,9.847,0,0,1,9.847,9.847ZM36.133,6.25A14.771,14.771,0,1,0,50.9,21.021,14.779,14.779,0,0,0,36.133,6.25Zm0,3.939A10.832,10.832,0,1,1,25.3,21.021,10.835,10.835,0,0,1,36.133,10.189Z",
    transform: "translate(-12.5 -6.25)",
    fill: "#2c2b34",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.5c9f30a74974dd0d513f52d9d6414cd7.svg";
export { ForwardRef as ReactComponent };